/**
 * Intent ids used by the MCP policy API (`byIntent[].id`).
 */
export const MCP_INTENT = {
  read: 'read',
  write: 'write',
  search: 'search',
  delete: 'delete',
  manage: 'manage',
} as const;

/** Display order for intent groups, irreversible ones last. */
export const MCP_INTENT_ORDER: readonly string[] = [
  MCP_INTENT.read,
  MCP_INTENT.write,
  MCP_INTENT.search,
  MCP_INTENT.delete,
  MCP_INTENT.manage,
];

/**
 * Intents that start unchecked and require a deliberate opt-in (delete /
 * manage). Used for default selection, read-only visibility, and the warning
 * flag — not for the "Irreversible results" lozenge.
 */
const OPT_IN_INTENT_IDS: ReadonlySet<string> = new Set([
  MCP_INTENT.delete,
  MCP_INTENT.manage,
]);

// TODO: Replace this UI-owned mapping with backend-provided irreversible metadata.
/** Intents that show the "Irreversible results" lozenge (delete only). */
const IRREVERSIBLE_BADGE_INTENT_IDS: ReadonlySet<string> = new Set([
  MCP_INTENT.delete,
]);

export function isIrreversibleIntent(intentId: string): boolean {
  return OPT_IN_INTENT_IDS.has(intentId);
}

export function showsIrreversibleResultsBadge(intentId: string): boolean {
  return IRREVERSIBLE_BADGE_INTENT_IDS.has(intentId);
}
